import { Navigate} from 'react-router-dom'
import Layout from '../layouts/layout'

const ProtectRouteAdmin = ()=>{
     
    const userData = JSON.parse(localStorage.getItem("userData"))

    return userData && (userData.userRole === "Admin" || userData.userRole === "SuperAdmin") ? <Layout/> : <Navigate to='/'/>
}
export default ProtectRouteAdmin